
import { defineComponent } from 'vue';
import {Expert, Event} from '@/types';
import ApiService from "../../services/api.service";

import SeminarHeader from '@/components/online-seminar/SeminarHeader.vue';
import ProgramSection from '@/components/online-seminar/ProgramSection.vue';
import KeyValueSection from '@/components/online-seminar/KeyValueSection.vue';
import CountrySeminarsSection from '@/components/online-seminar/CountrySeminarsSection.vue';
import FeaturesSection from '@/components/online-seminar/FeaturesSection.vue';
import BenefitsSection from '@/components/online-seminar/BenefitsSection.vue';
import ExpertsSection from '@/components/online-seminar/ExpertsSection.vue';

// Иконки стран для шапки, ключ — подстрока названия страны с exportcenter.ru
const COUNTRY_ICONS: Record<string, string> = {
  'Китай': 'china.svg',
  'Египет': 'egypt.svg',
  'Инди': 'india.svg',
  'Сауд': 'saudi.svg',
  'Эмират': 'oae.svg',
  'ОАЭ': 'oae.svg',
  'Турц': 'tourkie.svg',
  'Узбек': 'uz.png',
};

export default defineComponent({
  name: 'OnlineSeminar',
  components: {
    SeminarHeader,
    ProgramSection,
    KeyValueSection,
    CountrySeminarsSection,
    FeaturesSection,
    BenefitsSection,
    ExpertsSection,
  },
  data() {
    return {
      event: null as Event | null,
      icon: '/pic/online-seminar/kkt.svg',
      experts: [
        {
          pic: 'maslov.png',
          title: 'Алексей Маслов',
          text: 'Директор, профессор, доктор исторических наук<br/> Институт Стран Азии и Африк МГУ им. М.В. Ломоносова<br/>' +
              '<ul>' +
              '<li>современное развитие стран Азии </li>' +
              '<li>политическое и социально-экономическое развитие Китая </li>' +
              '<li>национальные традиции</li>' +
              '<li>бизнес и предпринимательство в Азии </li>' +
              '</ul>'
        },
        {
          pic: 'starodubcev.png',
          title: 'Иван Стародубцев',
          text: '' +
              '<ul>' +
              '<li>Независимый эксперт-практик: российско-турецкие отношения, сделки ВЭД, кросс-культурная деловая коммуникация.</li>' +
              '<li>Эксперт Института Ближнего Востока, Российского совета по международным делам.</li>' +
              '<li>Автор книг: «Топливно-энергетический комплекс Турции и энергетический фактор в российско-турецких отношениях», «Трансформирующаяся Турция», «Россия – Турция: 500 лет беспокойного соседства», «Турецкие диалоги-1» и «Турецкие диалоги-2», Учебное пособие ШЭ РЭЦ «Турецкая Республика. Особенности ведения бизнеса» (в печати).</li>' +
              '<li>Ведущий авторских программ на радио и ТВ</li>' +
              '</ul>'
        },
        {
          pic: 'eliseev.png',
          title: 'Вячеслав Елисеев',
          text: 'Генеральный директор ООО КА "ДЖОБ ФОР АРАБИСТС"<br/>' +
              '<ul>' +
              '<li>Организация B2B встреч с крупными компаниями на территории ОАЭ, перевод и локализация информационно-презентационных материалов на арабский язык, подготовка представителей компании к участию в международных выставках.</li>' +
              '<li>2021- 2022: организация деловых миссий в г. Дубай для компаний </li>' +
              '<li>2019: выступление в роли лектора практики в рамках 6th Access meeting Export Workshop «GLOBAL GULF TRADE» по теме «Экспорт в страны Персидского залива: результативный ВЭД и работа над ошибками».</li>' +
              '</ul>'
        },
        {
          pic: 'sadukzade.png',
          title: 'Садыгзаде Мурад Салех Оглы',
          text: 'Президент Российской ближневосточной ассоциации, приглашённый преподаватель Департамента зарубежного регионоведения НИУ ВШЭ, эксперт ливанского аналитического центра «Истишариа».<br/>' +
              '<ul>' +
              '<li>Президент Центра ближневосточных исследований</li>' +
              '<li>Приглашенный преподаватель НИУ ВШЭ, РАНХиГС, МГИМО</li>' +
              '<li>Эксперт Российского совета по международным делам</li>' +
              '<li>Эксперт ливанского форума Истишариа</li>' +
              '<li>Частный консультант по политическим рисками в БВСА</li>' +
              '</ul>'
        },
        {
          pic: 'griva.png',
          title: 'Грива Евгений Владимирович',
          text: 'Заместитель Торгового представителя Российской Федерации в Индии, экс-генеральный директор SIBUR Petrochemical India Pvt. Ltd., кандидат психологических наук, МВА, автор книги «Волшебная Индия, или как жить и управлять людьми в этой стране»<br/>' +
              '<ul>' +
              '<li>Кросс-культурный менеджмент</li>' +
              '<li>Международный бизнес</li>' +
              '<li>Управление персоналом в Южной Азии</li>' +
              '</ul>'
        },
        {
          pic: 'veselova.png',
          title: 'Людмила Веселова',
          text: 'Академический руководитель магистерских программ «Бизнес и политика в современной Азии» и «Международный бизнес в АТР», доцент, кандидат исторических наук НИУ ВШЭ (Санкт-Петербург)<br/>' +
              '<ul>' +
              '<li>7 лет активной работы с китайскими поставщиками и заводами, координация деятельности заводов в КНР.</li>' +
              '<li>Участие в проектах-заказах от РЖД по созданию осветительных приборов для локомотивов.</li>' +
              '<li>Опыт работы с компаниями, специализирующихся на сувенирной продукции, опыт реализации успешных проектов для компаний «Связной», «Сибирское здоровье», «Coca-Cola» и т.д.</li>' +
              '</ul>'
        }
      ] as Expert[]
    };
  },
  mounted() {
    //@ts-ignore
    this.$parent.init();
    this.loadEvent();
  },
  methods: {
    loadEvent() {
      // Ближайший страновой семинар парсится бэкендом с exportcenter.ru/events_exportedu/
      ApiService.get('staticpages/online-seminar').then(res => {
        const event = (res.data.events || []).find((e: any) => e.is_cross_cultural);
        if (!event) {
          return;
        }
        const country = event.country || event.title;
        const key = Object.keys(COUNTRY_ICONS).find(name => country.indexOf(name) !== -1);
        this.icon = '/pic/online-seminar/' + (key ? COUNTRY_ICONS[key] : 'kkt.svg');
        this.event = event as Event;
      });
    }
  }
});
